import get from 'lodash/get';
import {
    SYNC_MEMBER_DETAILS_IO_FROM_QUESTIONS,
    SET_MEMBER_DETAILS_IO_FAILED_SNAPSHOT,
} from '../types';
import { mergeOfferIntoOtherParams } from '../actions/requestOffers';
import {
    buildMemberDetailsIoFailedSnapshot,
    collectMemberDetailsAnswersFromState,
} from '../selector/memberDetails';
import { isMemberDetailsIoStatus } from '../utils/memberDetailsIoStatus';

const OFFER_KEYS = [
    'devId',
    'offerProductType',
    'offerPlanCode',
    'offerPricingM',
    'offerPricingA',
    'offerPricingS',
    'offerExpiration',
];

const isQuestionsSuccess = (type) => /^GET_[A-Z0-9_]+_SUCCESS$/.test(type);

const buildIoSyncPayload = (io) => {
    if (!io?.requoteRedirect) {
        return io;
    }

    return {
        ...io,
        blocking: false,
        requestOffersMessage: null,
        ioDataUpdateMessage: null,
        uspsMessage: null,
        uspsValidationStatus: isMemberDetailsIoStatus(io.uspsValidationStatus, 'blocked')
            ? null
            : io.uspsValidationStatus,
        uspsValidationTarget: null,
        requestOffersStatus: isMemberDetailsIoStatus(io.requestOffersStatus, 'valid_offer')
            ? null
            : io.requestOffersStatus,
        ioDataUpdateStatus: isMemberDetailsIoStatus(io.ioDataUpdateStatus, 'success')
            ? null
            : io.ioDataUpdateStatus,
    };
};

const shouldCaptureFailedSnapshot = (io) => io?.blocking && !io?.requoteRedirect;

const memberDetailsIoResponseMiddleware = ({ dispatch, getState }) => (next) => (action) => {
    const result = next(action);

    if (!isQuestionsSuccess(action.type)) {
        return result;
    }

    const otherParams = get(action, 'payload.other_params', {}) || {};
    const io = otherParams.member_details_io ?? null;
    const hasMemberDetailsIo = io && typeof io === 'object' && Object.keys(io).length > 0;
    if (hasMemberDetailsIo) {
        dispatch({
            type: SYNC_MEMBER_DETAILS_IO_FROM_QUESTIONS,
            payload: buildIoSyncPayload(io),
        });

        const offerPatch = {};
        OFFER_KEYS.forEach((key) => {
            const value = otherParams[key];
            if (value !== undefined && value !== null && value !== '') {
                offerPatch[key] = value;
            }
        });
        if (Object.keys(offerPatch).length > 0) {
            dispatch(mergeOfferIntoOtherParams(offerPatch));
        }

        if (shouldCaptureFailedSnapshot(io)) {
            const answersArray = collectMemberDetailsAnswersFromState(getState());
            dispatch({
                type: SET_MEMBER_DETAILS_IO_FAILED_SNAPSHOT,
                payload: buildMemberDetailsIoFailedSnapshot(answersArray, io),
            });
        } else {
            dispatch({
                type: SET_MEMBER_DETAILS_IO_FAILED_SNAPSHOT,
                payload: null,
            });
        }
    }

    return result;
};

export default memberDetailsIoResponseMiddleware;
